"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
var react_1 = __importDefault(require("react"));
var inertia_react_1 = require("@inertiajs/inertia-react");
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var ej2_react_grids_1 = require("@syncfusion/ej2-react-grids");
require("@syncfusion/ej2/tailwind.css");
require("@syncfusion/ej2-base/styles/tailwind.css");
require("@syncfusion/ej2-react-grids/styles/tailwind.css");
function formatDate(value) {
    if (!value) {
        return '';
    }
    var parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return value;
    }
    return new Intl.DateTimeFormat('en-AU').format(parsed);
}
function ContactInvoiceLineItems(_a) {
    var _b;
    var contact = _a.contact, invoice = _a.invoice, line_items = _a.line_items;
    var route = (0, useRoute_1.default)();
    var gridExtras = {
        loadingIndicator: { indicatorType: 'Spinner' },
        emptyRecordTemplate: function () { return (react_1.default.createElement("span", { className: "text-gray-500" }, "No line items found.")); },
    };
    return (react_1.default.createElement(AppLayout_1.default, { title: "Invoice ".concat((_b = invoice === null || invoice === void 0 ? void 0 : invoice.invoice_number) !== null && _b !== void 0 ? _b : invoice === null || invoice === void 0 ? void 0 : invoice.invoice_guid), renderHeader: function () {
            var _a, _b;
            return (react_1.default.createElement("div", { className: "flex items-center justify-between" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h2", { className: "font-semibold text-xl text-gray-800 leading-tight" },
                        "Line Items for ", (_a = invoice === null || invoice === void 0 ? void 0 : invoice.invoice_number) !== null && _a !== void 0 ? _a : 'Invoice'),
                    react_1.default.createElement("p", { className: "text-sm text-gray-500" }, (_b = contact === null || contact === void 0 ? void 0 : contact.name) !== null && _b !== void 0 ? _b : 'Contact',
                        (invoice === null || invoice === void 0 ? void 0 : invoice.date) ? " - ".concat(formatDate(invoice.date)) : '')),
                react_1.default.createElement(inertia_react_1.InertiaLink, { href: route('contacts.invoices', [contact.id]), className: "text-sm text-gray-600 hover:text-gray-900" }, "Back to Invoices")));
        } },
        react_1.default.createElement("div", { className: "py-12" },
            react_1.default.createElement("div", { className: "mx-auto sm:ps-6 lg:px-8" },
                react_1.default.createElement("div", { className: "bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4" },
                    react_1.default.createElement(ej2_react_grids_1.GridComponent, __assign({ id: "contact-invoice-line-items-grid", dataSource: line_items }, gridExtras, { allowPaging: true, allowSorting: true, allowFiltering: true, allowTextWrap: true, pageSettings: { pageSize: 25 }, sortSettings: {
                            columns: [{ field: 'description', direction: 'Ascending' }],
                        } }),
                        react_1.default.createElement(ej2_react_grids_1.ColumnsDirective, null,
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "description", headerText: "Description", width: "260" }),
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "item_code", headerText: "Item", width: "120" }),
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "account_code", headerText: "Account", width: "120" }),
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "quantity", headerText: "Qty", textAlign: "Right", width: "90" }),
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "unit_amount", headerText: "Unit", textAlign: "Right", format: "N2", width: "110" }),
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "line_amount", headerText: "Line Amount", textAlign: "Right", format: "N2", width: "140" }),
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "tax_amount", headerText: "Tax", textAlign: "Right", format: "N2", width: "110" }),
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "tax_type", headerText: "Tax Type" })),
                        react_1.default.createElement(ej2_react_grids_1.Inject, { services: [ej2_react_grids_1.Toolbar, ej2_react_grids_1.Sort, ej2_react_grids_1.Filter] })))))));
}
exports.default = ContactInvoiceLineItems;
